import { has } from "lodash";
import { Office } from "types/office";

export interface OfficeApiData {
  address1: string;
  address2: string;
  city: string;
  display_name: string;
  formatted_phone: string;
  formatted_zip_code: string;
  id: string;
  logical_id: string;
  scheduling_allowed: boolean;
  state_abbr: string;
  time_zone_name: string;
  distance_miles?: string;
  cobranded_logo_url?: string;
  vintage_name?: string;
  supports_medicaid?: boolean;
  hours?: string;
  start_date?: string;
  start_time?: string;
  total_slots?: string;
  total_slots_details?: string;
  office_uid: string;
  time_slot_weeks: number;
  restrict_veh: boolean;
  veh_discount: boolean;
  veh_namechange: boolean;
  age_restrict_veh: boolean;
  offers_veh: boolean;
  promo_display_name?: string;
  do_not_promote?: boolean;
  show_braze_banner?: boolean;
  hide_VEH_disclaimer?: boolean;
  office_test_group?: boolean;
  allow_multi_bookings_zocdoc?: boolean;
  is_bypass: boolean;
  show_medicaid_banner?: boolean;
  show_office_banner?: boolean;
  whitelabel?: boolean;
}

const schedulerBannerTypes = ["promo", "global", "medicaid", "office"];

export const buildOffice = (data: OfficeApiData): Office => {
  return {
    address1: data.address1,
    address2: data.address2,
    city: data.city,
    displayName: data.display_name,
    formattedPhone: data.formatted_phone,
    formattedZipCode: data.formatted_zip_code,
    id: data.id,
    logicalId: data.logical_id,
    officeUid: data.office_uid,
    schedulingAllowed: data.scheduling_allowed,
    stateAbbr: data.state_abbr,
    timeZoneName: data.time_zone_name,
    timeSlotWeeks: data.time_slot_weeks,
    restrictVEH: data.restrict_veh,
    discountVEH: data.veh_discount,
    offersVEH: data.offers_veh,
    ageRestrictVEH: data.age_restrict_veh,
    namechangeVEH: data.veh_namechange,
    isBypass: data.is_bypass,
    whitelabel: data.whitelabel,
    ...(has(data, "distance_miles") && {
      distanceMiles: Number(data.distance_miles).toFixed(1),
    }),
    ...(has(data, "cobranded_logo_url") && {
      cobrandedLogoUrl: data.cobranded_logo_url,
    }),
    ...(has(data, "vintage_name") && {
      vintageName: data.vintage_name,
    }),
    ...(has(data, "supports_medicaid") && {
      supportsMedicaid: data.supports_medicaid,
    }),
    ...(has(data, "hours") && {
      hours: data.hours,
    }),
    ...(has(data, "total_slots") && {
      totalSlots: data.total_slots,
    }),
    ...(has(data, "start_date") && {
      startDate: data.start_date,
    }),
    ...(has(data, "start_time") && {
      startTime: data.start_time,
    }),
    ...(has(data, "total_slots_details") && {
      totalSlotsDetails: data.total_slots_details,
    }),
    ...(has(data, "promo_display_name") && {
      promoDisplayName: data.promo_display_name,
    }),
    ...(has(data, "do_not_promote") && {
      doNotPromote: data.do_not_promote,
    }),
    ...(has(data, "show_braze_banner") && {
      showBrazeBanner: data.show_braze_banner,
    }),
    ...(has(data, "hide_VEH_disclaimer") && {
      hideVEHdisclaimer: data.hide_VEH_disclaimer,
    }),
    ...(has(data, "office_test_group") && {
      officeTestGroup: data.office_test_group,
    }),
    ...(has(data, "allow_multi_bookings_zocdoc") && {
      allowMultiBookingsZocdoc: data.allow_multi_bookings_zocdoc,
    }),
    ...(has(data, "show_medicaid_banner") && {
      showMedicaidBanner: data.show_medicaid_banner,
    }),
    ...(has(data, "show_office_banner") && {
      showOfficeBanner: data.show_office_banner,
    }),
    bannerTypes: schedulerBannerTypes,
  };
};
